import { SyntheticEvent } from 'react';

export const ignore = <T extends Event | SyntheticEvent>(event: T): void => {
  event.preventDefault();
  event.stopPropagation();
};
